export default "__VITE_ASSET__BMBs20K3__"